<template>
  <transition name="modal">
    <div class="modal-mask" v-if="isModalVisible">
      <div class="modal-wrapper">
        <div class="modal-container">
          <card>
            <div class="title">{{ title }}</div>
            <div class="checkmark-container" v-if="svgType === 'checkmark'">
              <svg class="checkmark">
                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                <path class="checkmark__check" fill="none" d="M16.1 29.2l7.1 7.2 16.7-16.8"/>
              </svg>
            </div>
            <div class="trash-container" v-if="svgType === 'trash'">
              <svg class="trash">
                <circle class="trash__circle" cx="26" cy="26" r="25" fill="none"/>
                <image class="trash__image" xlink:href="@/assets/static/img/discard.svg" />
              </svg>
            </div>
            <div class="message">{{ message }}</div>
          </card>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'

  export default {
    components: {
      Card,
    },
    computed: {
      title () {
        return this.$store.getters.modalTitle;
      },
      svgType() {
        return this.$store.getters.modalSVGType;
      },
      message () {
        return this.$store.getters.modalMessage;
      },
      isModalVisible () {
        return this.$store.getters.isModalVisible;
      },
    },
    data: function () {
      return {

      }
    },
  }
</script>
